import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import { Card, CardHeader, CardContent, Divider } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { getChartColors } from '../../../../utils/chartTheme';

const buildHourlySeries = data => {
  const byHour = {};
  (data || []).forEach(item => {
    const hour = item.Hour != null ? item.Hour : item.hour;
    byHour[hour] = item.Count != null ? item.Count : item.count;
  });

  const series = [];
  for (let hour = 0; hour < 24; hour++) {
    series.push({
      hour: `${String(hour).padStart(2, '0')}h`,
      count: byHour[hour] || 0
    });
  }
  return series;
};

const HourlyProductivityChart = memo(function HourlyProductivityChart(props) {
  const { data, intl } = props;
  const colors = getChartColors();
  const series = buildHourlySeries(data);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        avatar={<span className="mexx-dyn-color" style={{ '--mexx-dyn-color': colors.info, display: 'flex' }}><AccessTimeIcon /></span>}
        title={intl.formatMessage({ id: 'agentproductivity.dashboard.hourly.title', defaultMessage: 'Produtividade por hora (tickets resolvidos)' })} />
      <Divider />
      <CardContent>
        <div style={{ width: '100%', height: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series}>
              <CartesianGrid strokeDasharray="3 3" stroke={colors.gridLine} />
              <XAxis dataKey="hour" interval={1} tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="count"
                stroke={colors.primary}
                fill={colors.primaryLight}
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
});

export default injectIntl(HourlyProductivityChart);
